import { ContactFormPayload } from '../interface/contact.interface';

export type ContactErrors = Partial<Record<keyof ContactFormPayload, string>>;

const NAME_REGEX = /^[A-Za-zÀ-ÖØ-öø-ÿ\s'-]+$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/**
 * Validates a contact form payload against the backend rules:
 *  - name: 4-100 chars, letters and spaces only
 *  - email: valid email format
 *  - phone: optional, if provided must be 7-20 chars
 *  - subject: 3-200 chars
 *  - message: 10-2000 chars
 */
export function validateContact(payload: ContactFormPayload): ContactErrors {
  const errors: ContactErrors = {};

  const name = payload.name.trim();
  if (!name) {
    errors.name = 'Full name is required.';
  } else if (name.length < 4 || name.length > 100) {
    errors.name = 'Full name must be between 4 and 100 characters.';
  } else if (!NAME_REGEX.test(name)) {
    errors.name = 'Full name can only contain letters and spaces.';
  }

  const email = payload.email.trim();
  if (!email) {
    errors.email = 'Email is required.';
  } else if (!EMAIL_REGEX.test(email)) {
    errors.email = 'Please enter a valid email address.';
  }

  const phone = payload.phone?.trim() ?? '';
  if (phone && (phone.length < 7 || phone.length > 20)) {
    errors.phone = 'Phone number must be between 7 and 20 characters.';
  }

  const subject = payload.subject.trim();
  if (!subject) {
    errors.subject = 'Subject is required.';
  } else if (subject.length < 3 || subject.length > 200) {
    errors.subject = 'Subject must be between 3 and 200 characters.';
  }

  const message = payload.message.trim();
  if (!message) {
    errors.message = 'Message is required.';
  } else if (message.length < 10 || message.length > 2000) {
    errors.message = 'Message must be between 10 and 2000 characters.';
  }

  return errors;
}